import type { AlertStatuses, StatusHistory } from '../../../dashboard/queries/alerts'

import _ from '../../../../utils/lodash-optimized'
import moment from 'moment/moment'

export const DATETIME_FORMAT = 'MM/DD/YYYY [at] HH:mm z'
const LEVEL_DURATION = 4 * 60

export const alertsStatusesMap = {
  l1: { color: '#6CC049' },
  l2: { color: '#FA8D29' },
  l3: { color: '#FA8D29' },
  l4: { color: '#F2545A' },
  l5: { color: '#F2545A' }
}

interface GetMyStatusOutput {
  progress?: number
  remaining?: number
  state?: string
}

export const getMyStatus = (
  statusHistory: StatusHistory[] = [],
  myStatus: AlertStatuses,
  currentTimeISO8601: string
): GetMyStatusOutput => {
  const res = _.first(statusHistory.filter(s => s.status === myStatus)) ?? {
    start: null,
    end: null
  }

  const calculateState = (start: string | null, end: string | null, current: string): GetMyStatusOutput => {
    const currentTime = moment(current).valueOf()
    const startTime = moment(start).valueOf()
    const predictedEnd = moment(start)
      .clone()
      .add(LEVEL_DURATION, 's')
      .valueOf()
    const progressSeconds = currentTime - startTime
    const totalSeconds = predictedEnd - startTime
    const progress = Math.ceil((progressSeconds / totalSeconds) * 100)
    const remaining = Math.ceil((totalSeconds - progressSeconds) / 1000)
    const CTimeBetweenSTimeAndPE =
            currentTime > startTime && currentTime < predictedEnd

    if (!_.isNil(end) && currentTime >= moment(end).valueOf()) {
      return {
        state: 'finished',
        progress: 100
      }
    }

    if (
      (_.isNil(end) && CTimeBetweenSTimeAndPE) ||
            (!_.isNil(end) && currentTime < moment(end).valueOf())
    ) {
      return {
        progress,
        remaining,
        state: 'current'
      }
    }

    if (_.isNil(end) && currentTime > predictedEnd) {
      return {
        state: 'overtime'
      }
    }

    return { state: 'inactive' }
  }

  const result = calculateState(res.start, res.end, currentTimeISO8601)

  return {
    ...res,
    remaining: result.remaining,
    progress: result.progress,
    state: result.state
  }
}
